<template>
    <div class="alert bg-light p-6">
        {{feedback}}
    </div>
</template>

<script>

    import {mapState} from 'vuex'

    export default {

        computed: {
            ...mapState({
                form: state => state.form.form
            }),

            feedback() {
                return this.form.display_feedback 
                ? this.form.display_feedback
                : this.$t('form.Feedback default message')
            }
        }

    }
</script>